import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import ht from './locales/ht.json';

/**
 * Configuration i18next
 * Détecte la langue depuis l'URL (/:locale/*)
 * Langues supportées : français (fr), anglais (en), créole haïtien (ht)
 */
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            fr: { translation: fr },
            en: { translation: en },
            ht: { translation: ht },
        },
        fallbackLng: 'fr',
        supportedLngs: ['fr', 'en', 'ht'],
        interpolation: {
            escapeValue: false, // React échappe déjà les valeurs
        },
        detection: {
            order: ['path', 'navigator'],
            lookupFromPathIndex: 0, // Détecte la locale depuis le premier segment de l'URL
        },
    });

export default i18n;
